<template>
  <div class="app-maintenance-container">
    <div class="body d-flex flex-column">
      <p>
        <strong>{{ $t("message.maintenance.on") }}</strong>
      </p>
      <p>
        {{ $t("message.maintenance.details") }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-maintenance-container {
  height: 100vh;
  padding: 50px;

  .body {
    height: 100%;
    display: flex;
    background-color: #a2c0e2;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    padding: 80px;
    text-align: center;
    border-radius: 50px;
  }
}
</style>
